import { useSearchParams } from "react-router-dom";
import { useCallback } from "react";

export const useFilterActions = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const updateFilters = useCallback(
    (
      updates: Record<string, string | null>,
      opts?: { replace?: boolean },
    ) => {
      const newParams = new URLSearchParams(searchParams);

      Object.entries(updates).forEach(([key, value]) => {
        if (value === null || value === "" || value === "ALL") {
          newParams.delete(key);
        } else {
          newParams.set(key, value);
        }
      });

      setSearchParams(newParams, { replace: opts?.replace });
    },
    [searchParams, setSearchParams]
  );

  const resetFilters = useCallback(() => {
    setSearchParams(new URLSearchParams());
  }, [setSearchParams]);

  return { updateFilters, resetFilters };
};
